import { stripHtmlToText } from '@hapana/shared/web/utils/strip-html.util'

type RawCustomAlert = {
  alertId: string
  title: string
  description?: string | null
}

export type CustomAlertRow = {
  alertId: string
  title: string
  description: string
}

export const toCustomAlertRows = (customAlerts: RawCustomAlert[] | undefined): CustomAlertRow[] =>
  (customAlerts ?? []).map((alert) => ({
    alertId: alert.alertId,
    title: alert.title,
    description: stripHtmlToText(alert.description),
  }))
